import { render } from "./CouponImage.vue?vue&type=template&id=0630153f&scoped=true&ts=true"
import script from "./CouponImage.vue?vue&type=script&lang=ts"
export * from "./CouponImage.vue?vue&type=script&lang=ts"

import "./CouponImage.vue?vue&type=style&index=0&id=0630153f&scoped=true&lang=scss"

import exportComponent from "/builds/psj7085139/sam/samva-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0630153f"]])

export default __exports__